// Angular
import { Component } from '@angular/core';

// Formly
import { FieldType } from '@ngx-formly/core';

@Component({
    selector: 'formly-field-input',
    templateUrl: './input.type.component.html',
})
export class FormlyFieldInput extends FieldType {
    get type() {
        return this.to.type || 'text';
    }

    get maxlength() {
        return this.to.maxlength || 150;
    }
}
